import { onMounted, onUnmounted } from "vue-demi";
import { usePageStore } from "@/stores/pageHeader";
import { mdiAbacus } from "@mdi/js";

export function usePageSettings() {
  const pageStore = usePageStore();

  const setupPageSettings = () => {
    pageStore.pageTitle = "Masraf Takip";
    pageStore.pageIcon = mdiAbacus;
    pageStore.hasFullScreen = false;
    pageStore.hasDownload = false;
    pageStore.hasDownloadApi = true;
    pageStore.hasDateRangeAll = true;
    pageStore.hasDateRange = true;
    pageStore.hasActions = true;
  };

  onMounted(() => {
    setupPageSettings();
  });

  onUnmounted(() => {
    pageStore.pageSettingsClear();
  });

  return {
    pageStore,
    mdiAbacus,
  };
}
